import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import ProfitTrendModal from '../modals/ProfitTrendModal'
import {useState, useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {MIN_DATE_RANGE} from '../../utils'

const CustomerTypeRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)
  const {
    customerTypeEntityPerformanceChartData,
    isCustomerTypeEntityPerformanceChartDataLoading,
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,
    // Customer Type Profit Trend Modal Data
    customerTypeProfitTrendChartData,
    customerTypeProfitTrendKpiData,
    customerTypeProfitTrendWeeklyBreakdownData,
    isCustomerTypeProfitTrendDataLoading,
    onCustomerTypeProfitTrendIdChange,
  } = useContext(CustomerReportContext)

  return (
    <>
      <tr>
        <td>{row.customerTypeName}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&customer_type=${row.customerTypeName}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.totalCost}</td>
        <td>{row.totalSale}</td>
        <td>
          <span>{row.totalProfit}</span>
        </td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td>{row.contributedProfitPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.customerTypeName}
          entityName={`Profitability Report - ${row.customerTypeName}`}
          onEntityPerformanceChartIdChange={onCustomerTypeEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onCustomerTypeEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={
            onCustomerTypeEntityPerformanceChartDateRangeChange
          }
          entityPerformanceChartFilters={customerTypeEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isCustomerTypeEntityPerformanceChartDataLoading}
          entityPerformanceChartData={customerTypeEntityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.customerTypeName}
          entityName={row.customerTypeName}
          onProfitTrendIdChange={onCustomerTypeProfitTrendIdChange}
          isProfitTrendDataLoading={isCustomerTypeProfitTrendDataLoading}
          profitTrendChartData={customerTypeProfitTrendChartData}
          kpiData={customerTypeProfitTrendKpiData}
          weeklyBreakdownData={customerTypeProfitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default CustomerTypeRow
